import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/state/reducer";
import { UserError } from "../state/types";
import { User } from "src/common/models/user";
import { PageCard } from "src/common/styles/styles";
import { SystemDescriptions } from "src/common/descriptions";
import { SearchableTable } from "src/components/SearchableTable";
import { serviceLoading } from "src/common/apiLoader/state/selection";
import { GET_USERS_API } from "../state/actionTypes";
import { ColumnsType } from "antd/es/table";
import { ColumnsKeys, TABLE_COLUMNS } from "./config";
import { useEffect } from "react";
import { getUsersApi } from "../state/action";
import { useNavigate } from "react-router";
import { Urls } from "src/common/urls";
import useUserPermission from "src/hooks/useUserPermissions";
import { USER_SCOPES } from "src/hooks/UserPermission";
import { searchableTableUtils } from "src/components/SearchableTable/utils";
import { Button, Space, Tooltip } from "antd";
import { EditOutlined } from '@ant-design/icons'

interface ReduxProps {
    users: User[]
    error?: UserError
    isGettingUsers: boolean
}

export const Users = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { validateUserScopeForPage } = useUserPermission()

    useEffect(() => {
        validateUserScopeForPage(USER_SCOPES.USER_READ)
        dispatch(getUsersApi())
    }, [])

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        users: state.user.users || [],
        isGettingUsers: serviceLoading(state, [GET_USERS_API]),
        error: state.user.error,
    }))

    const descriptions = SystemDescriptions.PAGES.USER.USERS
    const commonDescriptions = SystemDescriptions.PAGES.COMMON

    const tblColumns: ColumnsType<User> = [
        ...TABLE_COLUMNS,
        {
            title: descriptions.TABLE_COLUMNS.ACTIONS,
            dataIndex: ColumnsKeys.ACTIONS,
            key: ColumnsKeys.ACTIONS,
            align: searchableTableUtils.alignment.centerAlign,
            render: (_, record: User) => {
                const handleEditClick = (serviceId: number) => {
                    navigate(Urls.FRONTEND.USER.EDIT_PAGE(serviceId))
                }

                return <Space size="middle">
                    <Tooltip title={commonDescriptions.ACTIONS.EDIT} >
                        <Button type="primary" ghost shape="circle" size="small"
                            icon={<EditOutlined />}
                            onClick={() => handleEditClick(record.id!)}
                        />
                    </Tooltip>
                </Space>
            },
        },
    ]

    const handleActionClick = () => {
        navigate(Urls.FRONTEND.USER.CREATE)
    }

    return (
        <PageCard
            size="small"
            title={descriptions.TITLE}
        >
            <SearchableTable
                showSearch
                showActionButton
                actionButtonLabel={descriptions.TABLE.ACTION_BUTTON}
                actionButtonOnClick={handleActionClick}
                showLoader={reduxProps.isGettingUsers}
                items={reduxProps.users}
                tableColumns={tblColumns}
                searchLabel={descriptions.TABLE.SEARCH_PLACEHOLDER}
            />
        </PageCard>
    )
}
